module.exports = __webpack_public_path__ + "img/apperweima.0b823467.jpg";